export * from '../src/components/wui-text/index.js';
//# sourceMappingURL=wui-text.js.map